import { SvgIcon, SvgIconProps } from "@mui/material";

type IconProps = SvgIconProps & {
	size?: number;
};

export const UploadMaskIcon = ({ size = 20, ...props }: IconProps) => {
	return (
		<SvgIcon width={size} height={size} viewBox="0 0 24 24" {...props}>
			<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
				<path
					d="M18.0361 8.31391V5.39724C18.0361 4.88155 17.8313 4.38697 17.4666 4.02231C17.102 3.65766 16.6074 3.4528 16.0917 3.4528L10.2584 3.4528M10.2584 3.4528L13.175 6.36947M10.2584 3.4528L13.175 0.536133M0.536133 10.2584L0.536133 13.175C0.536133 13.6907 0.740993 14.1853 1.10565 14.55C1.4703 14.9146 1.96488 15.1195 2.48058 15.1195L8.31391 15.1195M8.31391 15.1195L5.39724 12.2028M8.31391 15.1195L5.39724 18.0361M1.50836 0.536133L5.39724 0.536133C5.93419 0.536133 6.36947 0.971412 6.36947 1.50836L6.36947 5.39724C6.36947 5.93419 5.93419 6.36947 5.39724 6.36947L1.50836 6.36947C0.971412 6.36947 0.536133 5.93419 0.536133 5.39724L0.536133 1.50836C0.536133 0.971412 0.971412 0.536133 1.50836 0.536133ZM13.175 12.2028H17.0639C17.6009 12.2028 18.0361 12.6381 18.0361 13.175V17.0639C18.0361 17.6009 17.6009 18.0361 17.0639 18.0361H13.175C12.6381 18.0361 12.2028 17.6009 12.2028 17.0639V13.175C12.2028 12.6381 12.6381 12.2028 13.175 12.2028Z"
					stroke="#FAFAFA"
					strokeOpacity="0.85"
					strokeWidth="1.07143"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</SvgIcon>
	);
};
